import { render, staticRenderFns } from "./zlkz.vue?vue&type=template&id=03f0a660&"
import script from "./zlkz.vue?vue&type=script&lang=ts&"
export * from "./zlkz.vue?vue&type=script&lang=ts&"
import style0 from "./zlkz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports